import styled, { css } from 'styled-components'

const Container = styled.button`
  display: ${props => props.mobile ? css`block` : css`none`};
  padding: 14px;
  background: ${props => props.color};
  color: ${props => props.theme.cores.branco};
  border-radius: 5px;
  cursor: pointer;
  transition: all .5s;

  ${props => props.mobile ? css`
    width: 100%;
    margin-top: 0;
  ` : css`width: 286px;
    margin-top: 18px;
  `}
  > span {
    font-size: 18px;
  }

  @media(min-width: ${props => props.theme.mediaQuery.smallpc}) {
    display: ${props => props.mobile ? css`none` : css`block`};
  }
`

export { Container }
